<template>
	<div class="dashboard flex flex-column"  v-if="order">
    <section>
      <div class="section-content with-shadow">
        <div>
					<h2 class="pb-3">Riordina la tua ultima spesa</h2>
					<p>Rivedi i prodotti dell'ultima spesa del <b>{{ detailDate(order) }}</b> e riordinali con un click!</p>  
            <div>
              <SliderQ
                :maxNumSlides="6"
                :minSizeOfSlide="150"
                :minNumSlides="2"
              >
                <slide
                  v-for="(item, index) in order.recipes.concat(order.extras)"
									:key="index"
                  v-if="order.recipes"
                >
                  <small-item-box
                    :class="{'not-available': item.availability == 0}"
                    :itemTitle="item.title + quantityType(item) + quantity(item)" 
                    :itemImage="item.images.small ? item.images.small : item.images.big"
                    :itemUrl="item.url ? `/ricetta/${item.url}` : null"
                  />
                </slide>
              </SliderQ>
              <div class="mt-5 flex justify-content-start" v-if="order">
                <CTA
                  :content="$t('components.checkout.bill.rebuy')"
                  @click="setAlert(true)"
                />
              </div>
              <!-- Start: Alert per riordina prodotti -->
              <v-dialog v-model="alert" width="600" :fullscreen="!$mq.isDesktop()">
                <v-card class="pa-5 pb-10 text-center">

                  <div class="flex justify-content-end">
                    <v-btn @click="setAlert(false)" icon><i class="fas fa-close" style='font-size: 32px'/> </v-btn>
                  </div>

                  <div class="flex flex-column flex-vcenter mt-5">
                  <h2 class="mb-5">Attenzione</h2>
                  <i class="fas fa-exclamation-triangle fa-3x" style="color:var(--quomi-orange)"></i>
                  <p class="text-body-mid pt-5 px-5">Dopo aver cliccato su "riordina prodotti" vai alla cassa per confermare il tuo ordine. Il tuo carrello attuale verrà svuotato.</p>
                    <CTA
                      :loading="loadingRebuy"
                      :content="$t('components.checkout.bill.rebuy')"
                      @click="$_recreateOrder(order)"
                    />
                    <span class="alert-close" @click="setAlert(false)">Annulla</span>
                  </div>
                </v-card>
            </v-dialog>
            <!-- --End-- -->
            </div>
        </div>
      </div>
    </section>



	</div>
</template>

<script>
import SmallItemBox from '../Parts/SmallItemBox'
import { menuStore } from '../../store/menuStore'
import { recreateOrder } from '../../mixins/recreateOrder'

const moment = require('moment')

export default {
	props: {
		user: {
			type: Object,
			default () {
				return null
			}
		},

		order: {
			type: Object,
			default() {
				return null
			}
		}
	},

	components: {
		SmallItemBox,
	},

  mixins: [
		recreateOrder,
	],

	data () {
		return {
			loadingPayment: false,
			alert: false,
			loading: {
				cta: false,
				orders: false
			},
			loadingRebuy: false,
			menuStore: menuStore.state,
		}
	},
  
	computed: {
		currentOrder() {
			return this.user ? this.user.order : null;
		},

	},
	methods: {

		setAlert(alert) {
			this.alert = alert
		},

		detailDate(order) {
			return moment(order.date.delivery).locale('it').format('D MMMM YYYY')
		},

		quantity(item) {
			if(item.cg1) {
				return item.quantity
			}else {
				return item.quantity * 2
			}
		},

		quantityType(item) {
			if(item.cg1) {
				return ' Qt '
			} else {
				return ' Porz. '
			}
		},
	},

	mounted () {
		menuStore.loadCurrentMenu()
	}
}

</script>

<style scoped>
.rebuy-btn {
	width: fit-content;
	display: inline;
	border: 2px solid var(--quomi-primary);
	border-radius: 20px;
	color: var(--quomi-primary);
}

.alert-close {
	color: var(--quomi-red);
	text-decoration: underline;
}

.alert-close:hover {
	cursor: pointer;
}

.not-available {
	opacity: 0.4;
}
.container >>> .section-content {
	padding: 30px 50px;
}

.container >>> .shadow-box:hover::before {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.20);
}

.container >>> .slider-container.noArrows {
	margin: 0 0px;
}

.dashboard >>> section {
	padding: 10px 10px;
	position: relative;
}

.to-bottom {
	order: 1;
}

.dashboard .flex-listing >>> section {
	flex-grow: 1;
	flex-basis: calc(100% / 3 - 20px);
	min-width: 320px;
}

.flex-listing {
	width: 100%;
	max-width: 1240px;
	margin-left: auto;
	margin-right: auto;
}

.dashboard >>> section {
	width: 100%;
	max-width: 1240px;
	margin-left: auto;
	margin-right: auto;
}

@media (max-width: 1024px) {
}

@media only screen and (max-width: 768px) { 
  .dashboard >>> .btn { 
    width: 100%;
	padding: .75rem .75rem;
  }
} 

@media only screen and (max-width: 640px) {
	.dashboard >>> .shadow-box:not(.recipe):not(.slider-arrow)::after,
	.dashboard >>> .shadow-box:not(.recipe):not(.slider-arrow)::before {
		display: none;
	}

	.dashboard >>> .shadow-box:hover {
		box-shadow: none;
	}
	.dashboard >>> section {
		padding: 0;
	}

	.container >>> .section-content {
		padding: 30px 20px;
	}

	.news-cards {
		flex-direction: column;
	}
}

</style>
